import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { organisationReducer, OrganisationState } from './organisation/organisation.reducer';
import { branchReducer, BranchState } from './branch/branch.reducer';

export interface AppState {
  organisation: OrganisationState;
  branch: BranchState;
}

export const reducers: ActionReducerMap<AppState> = {
  organisation: organisationReducer,
  branch: branchReducer
};

export const metaReducers: MetaReducer<AppState>[] = [];